<template>
  <div class="mta-mcard" :class="{ 'mta-mcard--open': open }" @click="$emit('toggle')">
    <div class="mta-mcard__top">
      <div class="mta-mcard__name">{{ product.name }}</div>
      <span class="mta-mcard__caret">{{ open ? '−' : '+' }}</span>
    </div>
    <div class="mta-mcard__val">{{ value }}</div>
    <div class="mta-mcard__sub">{{ headline.def.label }} · {{ rangeLabel }}</div>
    <div class="mta-mcard__chips">
      <delta-chip :chip="prevChip" />
      <delta-chip :chip="yearChip" />
    </div>
    <div class="mta-mcard__spark">
      <sparkline :points="spark" :width="180" :height="38" />
    </div>
  </div>
</template>

<script>
import DeltaChip from './DeltaChip.vue'
import Sparkline from './Sparkline.vue'
import { deltaChip, fmt, sparkline, yearChip } from './metricsCalc'

/** One product card of the design (.mcard): headline metric, change chips and the 12-month sparkline. */
export default {
  name: 'MetricsProductCard',
  components: { DeltaChip, Sparkline },
  props: {
    product: { type: Object, required: true },
    headline: { type: Object, required: true },  // calc() of the head metric
    series: { type: Array, default: null },      // the head metric's monthly values
    endIndex: { type: Number, required: true },
    rangeLabel: { type: String, default: '' },
    open: { type: Boolean, default: false },
  },
  computed: {
    value () {
      return fmt(this.headline.cur, this.headline.def.fmt)
    },
    prevChip () {
      return deltaChip(this.headline, 'vs prev')
    },
    yearChip () {
      return yearChip(this.headline, 'vs last yr')
    },
    spark () {
      return sparkline(this.series, this.endIndex, 180, 38)
    },
  },
}
</script>
